import request from "@utils/request";

export function getConfig(type) {
    return request({
        url: "alert/config/" + type,
        method: "get",
    });
}

export function getConfigWithCancelToken(type, cancelTokenSource) {
    return request({
        url: "alert/config/" + type,
        method: "get",
        cancelTokenSource: cancelTokenSource,
    });
}

export function updateConfig(type, data) {
    return request({
        url: "alert/config/" + type,
        method: "put",
        data: data,
    });
}

export function createConfig(type, data) {
    return request({
        url: "alert/config/" + type,
        method: "post",
        data: data,
    });
}

export function deleteConfig(type, data) {
    return request({
        url: "alert/config/" + type,
        method: "delete",
        data: data,
    });
}

export function getTickMissingConfig(type, data) {
    return request({
        url: "alert/config/tick/missing-config",
        method: "get",
        data: data,
    });
}

export function getAlertHubThreshold(data, cancelTokenSource) {
    return request({
        url: "alert-hub-threshold",
        method: "get",
        params: data,
        cancelTokenSource: cancelTokenSource,
    });
}

export function deleteThresholdConfig(data) {
    return request({
        url: "alert-hub-threshold",
        method: "delete",
        data: data,
    });
}

export function updateAlertHubThreshold(data) {
    return request({
        url: "alert-hub-threshold",
        method: "put",
        data: data,
    });
}

export function getAlertHubConfigWithCancelToken(data, cancelTokenSource) {
    return request({
        url: "alert-hub/config",
        method: "get",
        params: data,
        cancelTokenSource: cancelTokenSource,
    });
}

export function createAlertHubConfig(data) {
    return request({
        url: "alert-hub/config",
        method: "post",
        data: data,
    });
}

export function updateAlertHubConfig(data) {
    return request({
        url: "alert-hub/config",
        method: "put",
        data: data,
    });
}

export function deleteAlertHubConfig(data) {
    return request({
        url: "alert-hub/config",
        method: "delete",
        data: data,
    });
}
